export default __webpack_public_path__ + "static/media/desert2.e06dcd78.webp";